<template>
  <div v-loading="$wait.waiting(_uid)">
    <div class="card-wrapper">
      <div class="card w-full">
        <div class="card-content">
          <div class="mt-s">
            <UserTable :prop-list="list" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CompanyUserService from "@app/services/companies/users";
import UserTable from "@components/Dashboard/Views/Pages/Company/Users/UserTable";
import { mapActions, mapGetters, mapMutations } from "vuex";
import joinByName from "@helpers/joinByName";
import _get from "lodash.get";
import parseSettings from "./providers/parseSettings";

export default {
  components: {
    UserTable,
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      const list = await CompanyUserService.getUsers();
      this.list = this.parseDataTable(list);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("errorStore", ["addNewError"]),
    ...mapMutations("loadingStore", ["setLoading"]),
    parseDataTable(list) {
      return list
        .filter(({ isActive }) => {
          return isActive;
        })
        .map(({ fullName, id, company, acl, settings, isActive }) => {
          const type = _get(acl, "roles", []);
          const companyRoles = joinByName(company.roles);
          const companyRpes = joinByName(company.rpe);
          const setting = parseSettings(settings);

          return {
            id,
            fullName,
            type: joinByName(type),
            companyRoles: companyRoles,
            companyRpes: companyRpes,
            settings: setting,
            isActive,
            tab: "profile",
          };
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
